import { AxiosInstance } from "axios"
import { CustomJob } from "../../../accounting/accounting/merchantCustomReports/customReportsTypes"

export enum MerchantSettingsCustomJobQuery {
    CUSTOM_JOBS_LIST = "custom-jobs-list-for-merchant",
}

type FetchCustomJobsParams = Readonly<{
    merchantId: number
    type?: string
}>

export type FetchCustomJobsResponse = Readonly<{
    customJobs: Array<CustomJob>
}>

export async function fetchCustomJobs(
    params: FetchCustomJobsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchCustomJobsResponse> {
    const { merchantId, ...rest } = params

    const url = `/merchants/${merchantId}/settings/customJobs`

    const { data } = await axios.get(url, {
        params: rest,
        signal,
    })

    return data
}
